// test1664
(1664 && 0);
